/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { type HttpResponse, I18nService } from '@dm/core';
import { type Dtree, type FileSystem } from 'app/common/types/mo';
import { ProductConfig } from 'app/config';
import { type Observable, forkJoin, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

import { InfigoService } from '../../../infigo.service';
import { RefreshComponent } from '../../RefreshComponent';
import { FileQuotaTableComponent } from '../../resource-table/file-quota-table/file-quota-table.component';
import { FileShareTableComponent } from '../../resource-table/file-share-table/file-share-table.component';
import { MemberDtreeTableComponent } from '../../resource-table/member-dtree-table/member-dtree-table.component';

@Component({
    selector: 'app-file-system-resource',
    templateUrl: './file-system-resource.component.html',
    styleUrls: ['../../resource.scss'],
})
export class FileSystemResourceComponent extends RefreshComponent {
    @Input() fileId;
    ProductConfig = ProductConfig;
    firstTabItem = this.i18n.get('common.nfsShare_lab');
    secondTabItem = this.i18n.get('common.cifsShare_lab');
    thirdTabItem = this.i18n.get('common.quota_title');
    fourthTabItem = this.i18n.get('common.dtree_lab');
    defaultActiveItem = this.firstTabItem;
    propName = 'fileId';
    dtreeData: Dtree[];
    fileSystemData: FileSystem;
    dtreeParams;
    checkOnlyShow = true;
    @ViewChild('fileShareTable', { static: true }) fileShareTable: FileShareTableComponent;
    @ViewChild('quotaTable', { static: true }) quotaTable: FileQuotaTableComponent;
    @ViewChild('dtreeTable', { static: true }) dtreeTable: MemberDtreeTableComponent;
    loading = true;

    constructor(private i18n: I18nService, public infigoService: InfigoService, public changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    requestInfo(): Observable<any> {
        return forkJoin([this.getFileSystemInfo(), this.getDtreeList().pipe(catchError((data) => of(data)))]);
    }

    handleRequest(value: any): void {
        const [file, dtree] = value;
        this.loading = false;
        this.fileSystemData = file.data;
        this.dtreeData = dtree.data;
        this.onOnlyShowFsChange();
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }

    // 获取DtreeList
    getDtreeList(): Observable<HttpResponse> {
        if (ProductConfig.isHideDtree) {
            return of({ data: [], result: null });
        }
        return this.infigoService.getDtrees(this.fileId)
            .pipe(takeUntil(this.$destroy));
    }

    // 获取FileSystem
    getFileSystemInfo(): Observable<HttpResponse> {
        return this.infigoService.getFileSystem(this.fileId)
            .pipe(takeUntil(this.$destroy));
    }

    onOnlyShowFsChange(): void {
        this.dtreeParams = {
            ID: this.checkOnlyShow ? this.fileSystemData.ID + '@0' : null,
            TYPE: 16445,
            vstoreId: this.fileSystemData.vstoreId,
        };
    }
}
